import React, { useEffect, useState } from 'react'
import { Box, IconButton, InputAdornment, Typography } from '@mui/material'
import PlayArrowRoundedIcon from '@mui/icons-material/PlayArrowRounded';
import { useDispatch, useSelector } from 'react-redux';
import CustomAutocomplete from '../../../../eventcreation/components/CustomAutoComplete';
import { objectToArray, removeWhiteSpaces, selectedLanguage } from '../../../../../utils/commonServices';
import { azureLanguageNames } from '../../../../../constants/constants';
import { LoadingButton } from '@mui/lab';
import useContentActions from '../../../hooks/useContentActions';
import betaLogo from '../../../../../assets/copilot_beta.png';

const TranslateText = () => {
    const userReducer = useSelector((state) => state.persistedReducers.userReducer);
    const scriptReducer = useSelector((state)=>state.scriptReducer)
    const contentReducer = useSelector((state)=>state.contentReducer)
    const dropdownReducer = useSelector((state)=>state.persistedReducers.dropdownReducer)
  const [language, setLanguage] = useState('en-US')
  const [storyboardPrompt, setStoryboardPrompt] = useState(scriptReducer.selected_project_details.description);
  const contentTypeId = dropdownReducer.project_type?.find(type=> removeWhiteSpaces(type.name)?.toLowerCase() == removeWhiteSpaces(contentReducer?.selected_content_details.content?.type)?.toLowerCase())?.id
  const dispatch = useDispatch();
  const {createContent, updateContent} = useContentActions();

  useEffect(()=> {
    if(!!contentReducer?.selected_content_details?.content?.language) {
    setLanguage(contentReducer?.selected_content_details?.content?.language)
    } else {
        setLanguage('en-US')
    }
  }, [contentReducer?.selected_content_details?.content?.language])

  //code to detect enter key for editing Organization Name
  // useEffect(() => {
  //   const keyDownHandler = (event) => {
  //     // console.log("key Parent", event.key)
  //     if (event.key === "Enter") {
  //       event.preventDefault();

  //       handleSendPrompt();
  //     }
  //   };
  //     document.addEventListener("keydown", keyDownHandler)
    

  //   return () => {
  //     document.removeEventListener("keydown", keyDownHandler);
  //   };
  // }, []);

  const goClickHandler=()=>{
  
    
    // if(scriptReducer.selected_project_details.project_type_id === 3) {
    //   setStoryboardPrompt(scriptReducer.selected_project_details?.contents?.length === 0 ? scriptReducer.selected_project_details?.description : text)
    //   //dispatch(updateUserState({storyboard_item_number: 1}))
    // } else {
      // const payload = {
      //   "contentTypeId": scriptReducer.selected_project_details.projectTypeId,
      //   "projectLength": `${scriptReducer.selected_project_details.length} seconds`,
      //  // "storyboardCount": parseInt(scriptReducer.selected_project_details.length)/5,    
      //   "projectId": scriptReducer.selected_project_details.id,
      //   "personaId": scriptReducer.selected_project_details.personaId,
      //   "prompt": scriptReducer.selected_project_details?.contents?.length === 0 ? scriptReducer.selected_project_details?.description : text

      // }
      // createContent(payload)
      const payload = {
        "projectTypeId": contentTypeId,
        "contentId": contentReducer.selected_content_details.id,
        "language": language,
       // "projectLength": `${scriptReducer.selected_project_details.length} seconds`,
        // "storyboardCount": scriptReducer.selected_project_details.projectTypeId === 3 ?   (parseInt(scriptReducer.selected_project_details.length) > 4 ? 4 : parseInt(scriptReducer.selected_project_details.length)): 0,    
        "projectId": scriptReducer.selected_project_details.id,
        "personaId": contentTypeId == 9 ? 1 : scriptReducer.selected_project_details.personaId,
        "prompt": "translate"

       }
    //    const createPayload = {
    //    query: {
    //     "contentTypeId": scriptReducer.selected_project_details.projectTypeId,
    //     "projectLength": scriptReducer.selected_project_details.length,
    //     "storyboardCount": scriptReducer.selected_project_details.projectTypeId === 3 ? (parseInt(scriptReducer.selected_project_details.length) > 3 ? 3 : parseInt(scriptReducer.selected_project_details.length)) : 0,    
    //     "projectId": scriptReducer.selected_project_details.id,
    //     "personaId": scriptReducer.selected_project_details.personaId,
    //   },
    //   data: {
    //      "prompt": text
    //     }
      


    //   }
      // const payload = {
      //   "projectTypeId": 1,
      //   "contentId": 23,
      //  // "projectLength": `${scriptReducer.selected_project_details.length} seconds`,
      //   "storyboardCount": parseInt(scriptReducer.selected_project_details.length)/5,    
      //   "projectId": 16,
      //   "personaId": 1,
      //   "prompt": scriptReducer.selected_project_details?.contents?.length === 0 ? scriptReducer.selected_project_details?.description : text

      // }
  // scriptReducer.selected_project_details?.contents?.length > 0 ? updateContent(payload) : createContent(createPayload)
  updateContent(payload)
   // setText('')
   // }
    
  }
 
//   useEffect(() => {
//     const keyDownHandler = (event) => {
//       if (event.key === "Enter") {
//         event.preventDefault();
//        if ((contentReducer?.create_content_open === false && contentReducer?.open_delete_popup === false) && text?.length > 5) { handleSendPrompt();}
//       }
//     };
//       document.addEventListener("keydown", keyDownHandler)
//     return () => {
//       document.removeEventListener("keydown", keyDownHandler);
//     };
//   }, [text, contentReducer?.create_content_open, contentReducer?.open_delete_popup]);

  return (
    <>
              
              <Box className ='flex row j-start a-center' sx={{width:  '100%' , gap: 1,  textAlign:'left',}}>  
              <Typography>Translate to :</Typography>            
              <Box  sx={{width:'40%', mt:{xl:2},}}>
                    <CustomAutocomplete
                          id="script_language"
                          options={ objectToArray(azureLanguageNames)}
                        //   onFocus={() => {
                        //     setScriptLengthValidationFlag(false)
                        //   }}
                        //   onBlur={() => setScriptLengthValidationFlag(true)}
                        //   required
                        //   errorFlag={scriptLengthValidationFlag && getErrorMsg("script_length", createProjectReducer.commonPageData.language, createProjectReducer.commonPageData?.projectTypeId) != ""}
                        //   errorMsg={getErrorMsg("script_length", createProjectReducer.commonPageData.language, createProjectReducer.commonPageData?.projectTypeId)}
                          value={selectedLanguage(language)}
                          onChange={(event, newValue) => {
                            setLanguage(newValue.id)
                              }}
                          label=""
                          placeholder={`Select the language`}
                          getOptionLabel={(option) =>
                              Object.keys(option).length > 0 ? `${option.name}` : ""
                          }
                          // renderInput={(params) => (
                          //   <TextField
                          //     {...params}
                          //     placeholder={`Select the language of your ${projectType}`}
                          //     required
                          //     error={
                          //       scriptLengthValidationFlag &&
                          //       getErrorMsg(
                          //         "script_length",
                          //         createProjectReducer.commonPageData.lengthId,
                          //         createProjectReducer.commonPageData?.projectTypeId
                          //       ) !== ""
                          //     }
                          //     helperText={
                          //       scriptLengthValidationFlag
                          //         ? getErrorMsg(
                          //             "script_length",
                          //             createProjectReducer.commonPageData.lengthId,
                          //             createProjectReducer.commonPageData?.projectTypeId
                          //           )
                          //         : ""
                          //     }
                          //     variant="outlined"
                          //     size="medium"
                          //   />
                          // )}
                          renderOption={(props, option, { index }) => (
                            <React.Fragment key={option.id}>
                              {index === 7 && (
                                <li style={{ borderTop: "1px dotted #000", margin: "4px 0" }} />
                              )}
                              <li {...props}>{option.name}</li>
                            </React.Fragment>
                          )}
                         // msgColor='red'
                      /> 
             </Box>

<LoadingButton
                   // size="small"
                    disabled={contentReducer?.selected_content_details?.content?.language  == language}
                    onClick={goClickHandler}
                    style={{borderRadius: '5px', backgroundColor:'#08231B', color:'#00D744', textTransform:'none', opacity: language == contentReducer?.selected_content_details?.content?.language ? '50%' : '100%' }} 
                    sx={{ fontSize:{xs:'8px',sm:'8px',md:'8px',lg:'10px',xl:'14px', }, mt:{xs:1, md:0.5, lg: 0,  xl:2}, mb: {xl:1}, fontWeight:600, width:{xs:'76px',sm:'76px',md:'50px',lg:'60px',xl:'129px'}, minWidth: '60px !important'}}
                  //  loading={status == 'loading'}
                    loadingPosition="start"
                    variant="contained"
                    >
                   Go
               </LoadingButton>   
               <Box sx={{mt: {sm:2, md: 1, lg: 0.5, xl: 1.5}}}>  
                  <img src={betaLogo} style={{height: '36px',}} />
                </Box>
                      </Box> 
              
    </>
  )
}

export default TranslateText